export default class Customer {
  constructor(mobile, name, family, type, creationTime, modificationTime) {
    this.mobile = mobile
    this.name = name
    this.family = family
    this.type = type
    this.creationTime = creationTime
    this.modificationTime = modificationTime
  }
}
